export const slotsData = {
  slots1: {
    redirectUrl: "/casino/ezugi/gonzoquest",
    imgUrl: "./images/slots/newCasino/SlotsImg2.jpg",
    name: "Gonzo Treasure Hunts",
  },
  slots2: {
    redirectUrl: "/casino/ezugi/asgardianstones",
    imgUrl: "./images/slots/newCasino/asgardianstones.jpg",
    name: "Asgardian Stones",
  },
  slots3: {
    redirectUrl: "/casino/ezugi/secrets",
    imgUrl: "./images/slots/newCasino/secrets-of-atlantis.jpg",
    name: "Secrets of Atlantis",
  },
  slots4: {
    redirectUrl: "/casino/ezugi/grandwheel",
    imgUrl: "./images/slots/newCasino/grand-wheel.jpg",
    name: "Grand Wheel",
  },
  slots5: {
    redirectUrl: "/casino/ezugi/Strike777",
    imgUrl: "./images/slots/newCasino/777strike.jpg",
    name: "777 Strike",
  },
  slots6: {
    redirectUrl: "/casino/ezugi/Nights1000",
    imgUrl: "./images/slots/newCasino/10001-nights.jpg",
    name: "10001 Nights",
  },
  slots7: {
    redirectUrl: "/casino/ezugi/CashUltimate",
    imgUrl: "./images/slots/newCasino/cash_ultimate.jpg",
    name: "Cash Ultimate",
  },
  slots8: {
    redirectUrl: "/casino/ezugi/CashVolt",
    imgUrl: "./images/slots/newCasino/cash_volt.jpg",
    name: "Cash Volt",
  },
  slots9: {
    redirectUrl: "/casino/ezugi/DazzleMegaways",
    imgUrl: "./images/slots/newCasino/dazzle_me_megaways.jpg",
    name: "Dazzle Me Megaways",
  },
  slots10: {
    redirectUrl: "/casino/ezugi/DivinieFortuneMegaways",
    imgUrl: "./images/slots/newCasino/divine_fortune_megaways.jpg",
    name: "Divine Fortune Megaways",
  },
  slots11: {
    redirectUrl: "/casino/ezugi/Dynamiteriches",
    imgUrl: "./images/slots/newCasino/dynamite_riches.jpg",
    name: "Dynamite Riches",
  },
  slots12: {
    redirectUrl: "/casino/ezugi/FortuneHouse",
    imgUrl: "./images/slots/newCasino/fortunehouse.jpg",
    name: "Fotune House",
  },
  slots13: {
    redirectUrl: "/casino/ezugi/FruitShopMegaways",
    imgUrl: "./images/slots/newCasino/Fruit_Shop_Megaways.jpg",
    name: "Fruit Shop Megaways",
  },
  slots14: {
    redirectUrl: "/casino/ezugi/GoldenCryptex",
    imgUrl: "./images/slots/newCasino/Golden_Cryptex.jpg",
    name: "Golden Cryptex",
  },
  slots15: {
    redirectUrl: "/casino/ezugi/GoldenTsar",
    imgUrl: "./images/slots/newCasino/Golden_Tsar.jpg",
    name: "Golden Tsar",
  },
  slots16: {
    redirectUrl: "/casino/ezugi/GorillaKingdom",
    imgUrl: "./images/slots/newCasino/Gorilla_Kingdom.jpg",
    name: "Gorilla Kingdom",
  },
  slots17: {
    redirectUrl: "/casino/ezugi/MystryReels",
    imgUrl: "./images/slots/newCasino/Mystery_Reels_Megaways.jpg",
    name: "Mystery Reels Megaways",
  },
  slots18: {
    redirectUrl: "/casino/ezugi/RageoftheSea",
    imgUrl: "./images/slots/newCasino/Rage_Of_The_Seas.jpg",
    name: "Rage Of The Seas",
  },
  slots19: {
    redirectUrl: "/casino/ezugi/ReelKingMegaways",
    imgUrl: "./images/slots/newCasino/Reel_King_Mega.jpg",
    name: "Reel King Mega",
  },
  slots20: {
    redirectUrl: "/casino/ezugi/TurnFortune",
    imgUrl: "./images/slots/newCasino/Turn_Your_Fortune.jpg",
    name: "Turn Your Fortune",
  },
  slots21: {
    redirectUrl: "/casino/ezugi/TwinSpinMegaways",
    imgUrl: "./images/slots/newCasino/Twin_Spin_Megaways.jpg",
    name: "Twin Spin Megaways",
  },
  slots22: {
    redirectUrl: "/casino/ezugi/WillysChills",
    imgUrl: "./images/slots/newCasino/Willys_Hot_Chillies.jpg",
    name: "Willys Hot Chillies",
  },
  slots23: {
    redirectUrl: "/casino/ezugi/ChineseTreasures",
    imgUrl: "./images/slots/newCasino/Chinese-Treasures.jpg",
    name: "Chinese Treasures",
  },
  slots24: {
    redirectUrl: "/casino/ezugi/DragonLuck",
    imgUrl: "./images/slots/newCasino/Dragon's-Luck.jpg",
    name: "Dragon's Luck",
  },
  slots25: {
    redirectUrl: "/casino/ezugi/DragonFire",
    imgUrl: "./images/slots/newCasino/Dragon's-Fire.jpg",
    name: "Dragon's Fire",
  },
  slots26: {
    redirectUrl: "/casino/ezugi/DragonLuckDeluxe",
    imgUrl: "./images/slots/newCasino/Dragon's-Luck-Deluxe.jpg",
    name: "Dragon's Luck Deluxe",
  },
  slots27: {
    redirectUrl: "/casino/ezugi/DragonLuckReel",
    imgUrl: "./images/slots/newCasino/Dragon's-Luck-Power-Reels.jpg",
    name: "Dragon's Luck Power Reels",
  },
  slots28: {
    redirectUrl: "/casino/ezugi/EpicJourney",
    imgUrl: "./images/slots/newCasino/Epic-Journey.jpg",
    name: "Epic Journey",
  },
  slots29: {
    redirectUrl: "/casino/ezugi/GodWealth",
    imgUrl: "./images/slots/newCasino/God-Of-Wealth.jpg",
    name: "God Of Wealth",
  },
  slots30: {
    redirectUrl: "/casino/ezugi/LuckyFortune",
    imgUrl: "./images/slots/newCasino/Lucky-Fortune-Cat.jpg",
    name: "Lucky Fortune Cat",
  },
  slots31: {
    redirectUrl: "/casino/ezugi/MagicGate",
    imgUrl: "./images/slots/newCasino/Magic-Gate.jpg",
    name: "Magic Gate",
  },
  slots32: {
    redirectUrl: "/casino/ezugi/GoldenTemple",
    imgUrl: "./images/slots/newCasino/Golden-Temple.jpg",
    name: "Golden Temple",
  },
  slots33: {
    redirectUrl: "/casino/ezugi/PhoenixPower",
    imgUrl: "./images/slots/newCasino/Phoenix-Fire-Power-Reels.jpg",
    name: "Phoenix Fire Power Reels",
  },
  slots34: {
    redirectUrl: "/casino/ezugi/GoldenOffer",
    imgUrl: "./images/slots/newCasino/Golden-Offer.jpg",
    name: "Golden Offer",
  },
  slots35: {
    redirectUrl: "/casino/ezugi/RAsLegend",
    imgUrl: "./images/slots/newCasino/RA's-Legend.jpg",
    name: "RA's Legend",
  },
  slots36: {
    redirectUrl: "/casino/ezugi/GonzoMegawaya",
    imgUrl: "./images/slots/newCasino/Gonzo's-Quest-Megaways.jpg",
    name: "Gonzo's Quest Megaways",
  },
  slots37: {
    redirectUrl: "/casino/ezugi/RainbowJAcket",
    imgUrl: "./images/slots/newCasino/Rainbow-Jackpots.jpg",
    name: "Rainbow Jackpots",
  },
  slots38: {
    redirectUrl: "/casino/ezugi/MegaPyramid",
    imgUrl: "./images/slots/newCasino/Mega-Pyramid.jpg",
    name: "Mega Pyramid",
  },
  slots39: {
    redirectUrl: "/casino/ezugi/Jimi_Hendrix",
    imgUrl: "./images/slots/newCasino/Jimi_Hendrix.jpg",
    name: "Jimi Hendrix",
  },
  slots40: {
    redirectUrl: "/casino/ezugi/Jumanji",
    imgUrl: "./images/slots/newCasino/Jumanji.jpg",
    name: "Jumanji",
  },
  slots41: {
    redirectUrl: "/casino/ezugi/MotorheadVideoSlot",
    imgUrl: "./images/slots/newCasino/Motorhead_Video_Slot.jpg",
    name: "Motorhead Video Slot",
  },
  slots42: {
    redirectUrl: "/casino/ezugi/Starburst",
    imgUrl: "./images/slots/newCasino/Starburst.jpg",
    name: "Starburst",
  },
  slots43: {
    redirectUrl: "/casino/ezugi/WarofGod",
    imgUrl: "./images/slots/newCasino/War-Of-Gods.jpg",
    name: "War Of Gods",
  },
  slots44: {
    redirectUrl: "/casino/ezugi/Christmas",
    imgUrl: "./images/slots/newCasino/Aloha-Christmas.jpg",
    name: "Aloha Christmas",
  },
  slots45: {
    redirectUrl: "/casino/ezugi/ClusterPays",
    imgUrl: "./images/slots/newCasino/Aloha-Cluster-Pays.jpg",
    name: "Aloha Cluster Pays",
  },
  slots46: {
    redirectUrl: "/casino/ezugi/AncientsBlessing",
    imgUrl: "./images/slots/newCasino/Ancients-Blessing.jpg",
    name: "Ancients Blessing",
  },
  slots47: {
    redirectUrl: "/casino/ezugi/AurumCodex",
    imgUrl: "./images/slots/newCasino/Aurum-Codex.jpg",
    name: "Aurum Codex",
  },
  slots48: {
    redirectUrl: "/casino/ezugi/GunsNRoses",
    imgUrl: "./images/slots/newCasino/Guns_N_Roses.jpg",
    name: "Guns N Roses",
  },
  slots49: {
    redirectUrl: "/casino/ezugi/BorisandBoo",
    imgUrl: "./images/slots/newCasino/Betty-Boris-and-Boo.jpg",
    name: "Betty Boris and Boo",
  },
  slots50: {
    redirectUrl: "/casino/ezugi/WildWest",
    imgUrl: "./images/slots/newCasino/Wild-Wild-West-The-Great-Train-Heist.jpg",
    name: "Wild West The Great Train Heist",
  },
  slots51: {
    redirectUrl: "/casino/ezugi/SteamTower",
    imgUrl: "./images/slots/newCasino/Steam-Tower.jpg",
    name: "Steam Tower",
  },
  slots52: {
    redirectUrl: "/casino/ezugi/ZeusLightning",
    imgUrl: "./images/slots/newCasino/Zeus-Lightning-Power-Reels.jpg",
    name: "Zeus Lightning Power Reels",
  },
  slots53: {
    redirectUrl: "/casino/ezugi/WingsofRa",
    imgUrl: "./images/slots/newCasino/Wings-of-Ra.jpg",
    name: "Wings of Ra",
  },
  slots54: {
    redirectUrl: "/casino/ezugi/Trillionaire",
    imgUrl: "./images/slots/newCasino/Trillionaire.jpg",
    name: "Trillionaire",
  },
  slots55: {
    redirectUrl: "/casino/ezugi/TreasureMine",
    imgUrl: "./images/slots/newCasino/Treasure-Mine.jpg",
    name: "Treasure Mine",
  },
  slots56: {
    redirectUrl: "/casino/ezugi/ThorVengeance",
    imgUrl: "./images/slots/newCasino/Thor's-Vengeance.jpg",
    name: "Thor's Vengeance",
  },
  slots57: {
    redirectUrl: "/casino/ezugi/RegalStreak",
    imgUrl: "./images/slots/newCasino/Regal-Streak.jpg",
    name: "Regal Streak",
  },
  slots58: {
    redirectUrl: "/casino/ezugi/RegalBeasts",
    imgUrl: "./images/slots/newCasino/Regal-Beasts.jpg",
    name: "Regal Beasts",
  },
  slots59: {
    redirectUrl: "/casino/ezugi/ReelKeeper",
    imgUrl: "./images/slots/newCasino/Reel-Keeper.jpg",
    name: "Reel Keeper",
  },
  slots60: {
    redirectUrl: "/casino/ezugi/RainbowJackpotsPowerLines",
    imgUrl: "./images/slots/newCasino/Rainbow-Jackpots-Power-Lines.jpg",
    name: "Rainbow Jackpots Power Lines",
  },
  slots61: {
    redirectUrl: "/casino/ezugi/PiggyRichesMegaways",
    imgUrl: "./images/slots/newCasino/Piggy-Riches-Megaways.jpg",
    name: "Piggy Riches Megaways",
  },
  slots62: {
    redirectUrl: "/casino/ezugi/JingleBells",
    imgUrl: "./images/slots/newCasino/Jingle-Bells.jpg",
    name: "Jingle Bells",
  },
  slots63: {
    redirectUrl: "/casino/ezugi/JackinaPot",
    imgUrl: "./images/slots/newCasino/Jack-in-a-Pot.jpg",
    name: "Jack in a Pot",
  },
  slots64: {
    redirectUrl: "/casino/ezugi/FiveStar",
    imgUrl: "./images/slots/newCasino/Five-Star.jpg",
    name: "Five Star",
  },
  slots65: {
    redirectUrl: "/casino/ezugi/BountyRaid",
    imgUrl: "./images/slots/newCasino/Bounty-Raid.jpg",
    name: "Bounty Raid",
  },
  slots66: {
    redirectUrl: "/casino/ezugi/MysteryReels2",
    imgUrl: "./images/slots/newCasino/Mystery-Reels.jpg",
    name: "Mystery Reels",
  },
  slots67: {
    redirectUrl: "/casino/ezugi/DiamondBlitz",
    imgUrl: "./images/slots/newCasino/Diamond-Blitz.jpg",
    name: "Diamond Blitz",
  },
  slots68: {
    redirectUrl: "/casino/ezugi/DragonFireMegaways",
    imgUrl: "./images/slots/newCasino/Dragon's-Fire-Megaways.jpg",
    name: "Dragon's Fire Megaways",
  },
  slots69: {
    redirectUrl: "/casino/ezugi/Rome",
    imgUrl: "./images/slots/newCasino/Rome-The-Golden-Age.jpg",
    name: "Rome-The Golden Age",
  },
  slots70: {
    redirectUrl: "/casino/ezugi/ReelRush",
    imgUrl: "./images/slots/newCasino/Reel-Rush.jpg",
    name: "Reel Rush",
  },
  slots71: {
    redirectUrl: "/casino/ezugi/BloodSuckers",
    imgUrl: "./images/slots/newCasino/Blood-Suckers.jpg",
    name: "Blood Suckers",
  },
  slots72: {
    redirectUrl: "/casino/ezugi/BloodSuckers2",
    imgUrl: "./images/slots/newCasino/Blood-Suckers-2.jpg",
    name: "Blood Suckers 2",
  },
  slots73: {
    redirectUrl: "/casino/ezugi/Pyramid",
    imgUrl: "./images/slots/newCasino/Pyramid-Quest-for-Immortality.jpg",
    name: "Pyramid Quest for Immortality",
  },
  slots74: {
    redirectUrl: "/casino/ezugi/ButterflyStaxx",
    imgUrl: "./images/slots/newCasino/Butterfly-Staxx.jpg",
    name: "Butterfly Staxx",
  },
  slots75: {
    redirectUrl: "/casino/ezugi/ButterflyStaxx2",
    imgUrl: "./images/slots/newCasino/Butterfly-Staxx-2.jpg",
    name: "Butterfly Staxx 2",
  },
  slots76: {
    redirectUrl: "/casino/ezugi/PiggyRiches",
    imgUrl: "./images/slots/newCasino/Piggy-Riches.jpg",
    name: "Piggy Riches",
  },
  slots77: {
    redirectUrl: "/casino/ezugi/DarkKing",
    imgUrl: "./images/slots/newCasino/Dark-King-Forbidden-Riches.jpg",
    name: "Dark King Forbidden Riches",
  },
  slots78: {
    redirectUrl: "/casino/ezugi/JingleBellsPowerReels",
    imgUrl: "./images/slots/newCasino/Jingle-Bells-Power-Reels.jpg",
    name: "Jingle Bells Power Reels",
  },
  slots79: {
    redirectUrl: "/casino/ezugi/Dazzle",
    imgUrl: "./images/slots/newCasino/Dazzle-Me.jpg",
    name: "Dazzle Me",
  },
  slots80: {
    redirectUrl: "/casino/ezugi/JackHammer",
    imgUrl: "./images/slots/newCasino/Jack-Hammer.jpg",
    name: "Jack Hammer",
  },
  slots81: {
    redirectUrl: "/casino/ezugi/JackHammer2",
    imgUrl: "./images/slots/newCasino/Jack-Hammer-2-Fishy-Business.jpg",
    name: "Jack Hammer 2 Fishy Business",
  },
  slots82: {
    redirectUrl: "/casino/ezugi/DeadorAlive",
    imgUrl: "./images/slots/newCasino/Dead-or-Alive.jpg",
    name: "Dead or Alive",
  },
  slots83: {
    redirectUrl: "/casino/ezugi/DeadorAlive2",
    imgUrl: "./images/slots/newCasino/Dead-or-Alive-2.jpg",
    name: "Dead or Alive 2",
  },
  slots84: {
    redirectUrl: "/casino/ezugi/DeadorAlive2FeatureBuy",
    imgUrl: "./images/slots/newCasino/Dead-or-Alive-2-Feature-Buy.jpg",
    name: "Dead or Alive 2 Feature Buy",
  },
  slots85: {
    redirectUrl: "/casino/ezugi/JackandtheBeanstalk",
    imgUrl: "./images/slots/newCasino/Jack-and-the-Beanstalk.jpg",
    name: "Jack and the Beanstalk",
  },
  slots86: {
    redirectUrl: "/casino/ezugi/JingleSpin",
    imgUrl: "./images/slots/newCasino/Jingle-Spin.jpg",
    name: "Jingle Spin",
  },
  slots87: {
    redirectUrl: "/casino/ezugi/GordonRamsayHellsKitchen",
    imgUrl: "./images/slots/newCasino/Gordon_Ramsay_Hells_Kitchen.jpg",
    name: "Gordon Ramsay Hells Kitchen",
  },
  slots88: {
    redirectUrl: "/casino/ezugi/Elements",
    imgUrl: "./images/slots/newCasino/Elements-The-Awakening.jpg",
    name: "Elements The Awakening",
  },
  slots89: {
    redirectUrl: "/casino/ezugi/GonzosQuest",
    imgUrl: "./images/slots/newCasino/Gonzos_Quest.jpg",
    name: "Gonzos Quest",
  },
  slots90: {
    redirectUrl: "/casino/ezugi/FinnandtheSwirlySpin",
    imgUrl: "./images/slots/newCasino/Finn-and-the-Swirly-Spin.jpg",
    name: "Finn and the Swirly Spin",
  },
  slots91: {
    redirectUrl: "/casino/ezugi/FruitShop",
    imgUrl: "./images/slots/newCasino/Fruit-Shop.jpg",
    name: "Fruit Shop",
  },
  // slots92: {
  //   redirectUrl: "/casino/ezugi/DazzleMegaways",
  //   imgUrl: "./images/slots/newCasino/Dazzle-Me.jpg
  //   name: "Dazzle Me",
  // },
  slots93: {
    redirectUrl: "/casino/ezugi/DoubleStacks",
    imgUrl: "./images/slots/newCasino/Double-Stacks.jpg",
    name: "Double Stacks",
  },
  slots94: {
    redirectUrl: "/casino/ezugi/FairytaleLegends",
    imgUrl: "./images/slots/newCasino/Fairytale-Legends-Red-Riding-Hood.jpg",
    name: "Fairytale Legends Red Riding Hood",
  },
  slots95: {
    redirectUrl: "/casino/ezugi/Flowers",
    imgUrl: "./images/slots/newCasino/Flowers.jpg",
    name: "Flowers",
  },
  slots96: {
    redirectUrl: "/casino/ezugi/FruitShopChristmasEdition",
    imgUrl: "./images/slots/newCasino/Fruit-Shop-Christmas-Edition.jpg",
    name: "Fruit Shop Christmas Edition",
  },
  slots97: {
    redirectUrl: "/casino/ezugi/Hotline",
    imgUrl: "./images/slots/newCasino/Hotline.jpg",
    name: "Hotline",
  },
  slots98: {
    redirectUrl: "/casino/ezugi/Hotline2",
    imgUrl: "./images/slots/newCasino/Hotline-2.jpg",
    name: "Hotline 2",
  },
  slots99: {
    redirectUrl: "/casino/ezugi/TheInvisibleMan",
    imgUrl: "./images/slots/newCasino/The_Invisible_Man.jpg",
    name: "The Invisible Man",
  },
  slots100: {
    redirectUrl: "/casino/ezugi/IrishPotLuck",
    imgUrl: "./images/slots/newCasino/Irish-Pot-Luck.jpg",
    name: "Irish Pot Luck",
  },
  slots101: {
    redirectUrl: "/casino/ezugi/FruitSpin",
    imgUrl: "./images/slots/newCasino/Fruit-Spin.jpg",
    name: "Fruit Spin",
  },
  slots102: {
    redirectUrl: "/casino/ezugi/JungleSpirit",
    imgUrl: "./images/slots/newCasino/Jungle-Spirit-Call-of-the-Wild.jpg",
    name: "Jungle Spirit Call of the Wild",
  },
  slots103: {
    redirectUrl: "/casino/ezugi/KoiPrincess",
    imgUrl: "./images/slots/newCasino/Koi-Princess.jpg",
    name: "Koi Princess",
  },
  slots104: {
    redirectUrl: "/casino/ezugi/DriveMultiplierMayhem",
    imgUrl: "./images/slots/newCasino/Drive-Multiplier-Mayhem.jpg",
    name: "Drive Multiplier Mayhem",
  },
  slots105: {
    redirectUrl: "/casino/ezugi/RageoftheSeas",
    imgUrl: "./images/slots/newCasino/Rage-of-the-Seas.jpg",
    name: "Rage of the Seas",
  },
  slots106: {
    redirectUrl: "/casino/ezugi/RichesofMidgard",
    imgUrl: "./images/slots/newCasino/Riches-of-Midgard-Land-and-Expand.jpg",
    name: "Riches of Midgard Land and Expand",
  },
  slots107: {
    redirectUrl: "/casino/ezugi/ScruffyDuck",
    imgUrl: "./images/slots/newCasino/Scruffy-Duck.jpg",
    name: "Scruffy Duck",
  },
  slots108: {
    redirectUrl: "/casino/ezugi/SecretoftheStones",
    imgUrl: "./images/slots/newCasino/Secret-of-the-Stones.jpg",
    name: "Secret of the Stones",
  },
  slots109: {
    redirectUrl: "/casino/ezugi/SecretsofChristmas",
    imgUrl: "./images/slots/newCasino/Secrets-of-Christmas.jpg",
    name: "Secret of Christmas",
  },
  slots110: {
    redirectUrl: "/casino/ezugi/SerengetiKings",
    imgUrl: "./images/slots/newCasino/Serengeti-Kings.jpg",
    name: "Serengeti Kings",
  },
  slots111: {
    redirectUrl: "/casino/ezugi/SpaceWars",
    imgUrl: "./images/slots/newCasino/Space-Wars.jpg",
    name: "Space Wars",
  },
  slots112: {
    redirectUrl: "/casino/ezugi/Victorious",
    imgUrl: "./images/slots/newCasino/Victorious.jpg",
    name: "Victorious",
  },
  slots113: {
    redirectUrl: "/casino/ezugi/Warlords",
    imgUrl: "./images/slots/newCasino/Warlords-Crystal-of-Power.jpg",
    name: "Warlords Crystal of Power",
  },
  slots114: {
    redirectUrl: "/casino/ezugi/WildWater",
    imgUrl: "./images/slots/newCasino/Wild-Water.jpg",
    name: "Wild Water",
  },
  slots115: {
    redirectUrl: "/casino/ezugi/WildWorlds",
    imgUrl: "./images/slots/newCasino/Wild-Worlds.jpg",
    name: "Wild Worlds",
  },
  slots116: {
    redirectUrl: "/casino/ezugi/Squad4",
    imgUrl: "./images/slots/newCasino/4-Squad.jpg",
    name: "4 Squad",
  },
  slots117: {
    redirectUrl: "/casino/ezugi/Families5",
    imgUrl: "./images/slots/newCasino/5-Families.jpg",
    name: "5 Families",
  },
  slots118: {
    redirectUrl: "/casino/ezugi/AgentRoyale",
    imgUrl: "./images/slots/newCasino/Agent-Royale.jpg",
    name: "Agent Royale",
  },
  slots119: {
    redirectUrl: "/casino/ezugi/ArcadeBomb",
    imgUrl: "./images/slots/newCasino/Arcade-Bomb.jpg",
    name: "Arcade Bomb",
  },
  slots120: {
    redirectUrl: "/casino/ezugi/Atlantis",
    imgUrl: "./images/slots/newCasino/Atlantis.jpg",
    name: "Atlantis",
  },
  slots121: {
    redirectUrl: "/casino/ezugi/AztecSpins",
    imgUrl: "./images/slots/newCasino/Aztec-Spins.jpg",
    name: "Aztec Spins",
  },
  slots122: {
    redirectUrl: "/casino/ezugi/CinderellaBall",
    imgUrl: "./images/slots/newCasino/Cinderella`s-Ball.jpg",
    name: "Cinderella`s Ball",
  },
  slots123: {
    redirectUrl: "/casino/ezugi/CirquedelaFortune",
    imgUrl: "./images/slots/newCasino/Cirque-de-la-Fortune.jpg",
    name: "Cirque de la Fortune",
  },
  slots124: {
    redirectUrl: "/casino/ezugi/ClashoftheBeasts",
    imgUrl: "./images/slots/newCasino/Clash-of-the-Beasts.jpg",
    name: "Clash of the Beasts",
  },
  slots125: {
    redirectUrl: "/casino/ezugi/CrazyGenie",
    imgUrl: "./images/slots/newCasino/Crazy-Genie.jpg",
    name: "Crazy Genie",
  },
  slots126: {
    redirectUrl: "/casino/ezugi/CrystalMirror",
    imgUrl: "./images/slots/newCasino/Crystal-Mirror.jpg",
    name: "Crystal Mirror",
  },
  slots127: {
    redirectUrl: "/casino/ezugi/DaVinciMystery",
    imgUrl: "./images/slots/newCasino/Da-Vinci`s-Mystery.jpg",
    name: "Da-Vinci`s Mystery",
  },
  slots128: {
    redirectUrl: "/casino/ezugi/DevilNumber",
    imgUrl: "./images/slots/newCasino/Devil`s-Number.jpg",
    name: "Devil`s Number",
  },
  slots129: {
    redirectUrl: "/casino/ezugi/DiceDice",
    imgUrl: "./images/slots/newCasino/Dice-Dice-Dice.jpg",
    name: "Dice Dice Dice",
  },
  slots130: {
    redirectUrl: "/casino/ezugi/FiveStarsPowerReels",
    imgUrl: "./images/slots/newCasino/Five-Stars-Power-Reels.jpg",
    name: "Five Stars Power Reels",
  },
  slots131: {
    redirectUrl: "/casino/ezugi/GemsGoneWildPowerReels",
    imgUrl: "./images/slots/newCasino/Gems-Gone-Wild-Power-Reels.jpg",
    name: "Gems Gone Wild Power Reels",
  },
  slots132: {
    redirectUrl: "/casino/ezugi/GemsGoneWild",
    imgUrl: "./images/slots/newCasino/Gems-Gone-Wild.jpg",
    name: "Gems Gone Wild",
  },
  slots133: {
    redirectUrl: "/casino/ezugi/GoldenLeprechaunMegaways",
    imgUrl: "./images/slots/newCasino/Golden-Leprechaun-Megaways.jpg",
    name: "GoldenLeprechaun Megaways",
  },
  slots134: {
    redirectUrl: "/casino/ezugi/HoardofPoseidon",
    imgUrl: "./images/slots/newCasino/Hoard-of-Poseidon.jpg",
    name: "Hoard of Poseidon",
  },
  slots135: {
    redirectUrl: "/casino/ezugi/JewelScarabs",
    imgUrl: "./images/slots/newCasino/Jewel-Scarabs.jpg",
    name: "Jewel Scarabs",
  },
  slots136: {
    redirectUrl: "/casino/ezugi/LegendofAthena",
    imgUrl: "./images/slots/newCasino/Legend-of-Athena.jpg",
    name: "Legend of Athena",
  },
  slots137: {
    redirectUrl: "/casino/ezugi/LuckyHalloween",
    imgUrl: "./images/slots/newCasino/Lucky-Halloween.jpg",
    name: "Lucky Halloween",
  },
  slots138: {
    redirectUrl: "/casino/ezugi/LuckyLittleDevil",
    imgUrl: "./images/slots/newCasino/Lucky-Little-Devil.jpg",
    name: "Lucky Little Devil",
  },
  slots139: {
    redirectUrl: "/casino/ezugi/LuckyValentine",
    imgUrl: "./images/slots/newCasino/Lucky-Valentine.jpg",
    name: "Lucky Valentine",
  },
  slots140: {
    redirectUrl: "/casino/ezugi/LuckyWizard",
    imgUrl: "./images/slots/newCasino/Lucky-Wizard.jpg",
    name: "Lucky Wizard",
  },
  slots141: {
    redirectUrl: "/casino/ezugi/Masquerade",
    imgUrl: "./images/slots/newCasino/Masquerade.jpg",
    name: "Masquerade",
  },
  slots142: {
    redirectUrl: "/casino/ezugi/MayanGods",
    imgUrl: "./images/slots/newCasino/Mayan-Gods.jpg",
    name: "Mayan Gods",
  },
  slots143: {
    redirectUrl: "/casino/ezugi/MegaDragon",
    imgUrl: "./images/slots/newCasino/Mega-Dragon.jpg",
    name: "Mega Dragon",
  },
  slots144: {
    redirectUrl: "/casino/ezugi/MegaJade",
    imgUrl: "./images/slots/newCasino/Mega-Jade.jpg",
    name: "Mega Jade",
  },
  slots145: {
    redirectUrl: "/casino/ezugi/MegaRise",
    imgUrl: "./images/slots/newCasino/Mega-Rise.jpg",
    name: "Mega Rise",
  },
  slots146: {
    redirectUrl: "/casino/ezugi/MultiplierRiches",
    imgUrl: "./images/slots/newCasino/Multiplier-Riches.jpg",
    name: "Multiplier Riches",
  },
  slots147: {
    redirectUrl: "/casino/ezugi/MysteryReelsMegaways",
    imgUrl: "./images/slots/newCasino/Mystery_Reels_Megaways.jpg",
    name: "Mystery Reels Megaways",
  },
  slots148: {
    redirectUrl: "/casino/ezugi/NinjaWays",
    imgUrl: "./images/slots/newCasino/Ninja-Ways.jpg",
    name: "Ninja Ways",
  },
  slots149: {
    redirectUrl: "/casino/ezugi/PathofDestiny",
    imgUrl: "./images/slots/newCasino/Path-of-Destiny.jpg",
    name: "Path of Destiny",
  },
  slots150: {
    redirectUrl: "/casino/ezugi/PersianFortune",
    imgUrl: "./images/slots/newCasino/Persian-Fortune.jpg",
    name: "Persian Fortune",
  },
  slots151: {
    redirectUrl: "/casino/ezugi/ReelHeist",
    imgUrl: "./images/slots/newCasino/Reel-Heist.jpg",
    name: "Reel Heist",
  },
  slots152: {
    redirectUrl: "/casino/ezugi/RobinHoodWildForest",
    imgUrl: "./images/slots/newCasino/Robin-Hood`s-Wild-Forest.jpg",
    name: "Robin Hood`s Wild Forest",
  },
  slots153: {
    redirectUrl: "/casino/ezugi/SnowWild",
    imgUrl: "./images/slots/newCasino/Snow-Wild-And-The-7-Features.jpg",
    name: "Snow Wild And The 7 Features",
  },
  slots154: {
    redirectUrl: "/casino/ezugi/SylvanSpirits",
    imgUrl: "./images/slots/newCasino/Sylvan-Spirits.jpg",
    name: "Sylvan Spirits",
  },
  slots155: {
    redirectUrl: "/casino/ezugi/TheGreatestTrainRobbery",
    imgUrl: "./images/slots/newCasino/The-Greatest-Train-Robbery.jpg",
    name: "The Greatest Train Robbery",
  },
  slots156: {
    redirectUrl: "/casino/ezugi/TheWildHatter",
    imgUrl: "./images/slots/newCasino/The-Wild-Hatter.jpg",
    name: "The Wild Hatter",
  },
  slots157: {
    redirectUrl: "/casino/ezugi/ThorLightning",
    imgUrl: "./images/slots/newCasino/Thor`s-Lightning.jpg",
    name: "Thor`s Lightning",
  },
  slots158: {
    redirectUrl: "/casino/ezugi/TikiFruits",
    imgUrl: "./images/slots/newCasino/Tiki-Fruits.jpg",
    name: "Tiki Fruits",
  },

  slots159: {
    redirectUrl: "/casino/ezugi/TotemLightning",
    imgUrl: "./images/slots/newCasino/Totem-Lightning.jpg",
    name: "Totem Lightning",
  },
  slots160: {
    redirectUrl: "/casino/ezugi/VaultCracker",
    imgUrl: "./images/slots/newCasino/Vault-Cracker.jpg",
    name: "Vault Cracker",
  },
  slots161: {
    redirectUrl: "/casino/ezugi/VaultofAnubis",
    imgUrl: "./images/slots/newCasino/Vault-of-Anubis.jpg",
    name: "Vault of Anubis",
  },
  slots162: {
    redirectUrl: "/casino/ezugi/WellofWishes",
    imgUrl: "./images/slots/newCasino/Well-of-Wishes.jpg",
    name: "Well of Wishes",
  },
  slots163: {
    redirectUrl: "/casino/ezugi/WildCatsMultiline",
    imgUrl: "./images/slots/newCasino/Wild-Cats-Multiline.jpg",
    name: "Wild Cats Multiline",
  },
  slots164: {
    redirectUrl: "/casino/ezugi/WildOClock",
    imgUrl: "./images/slots/newCasino/Wild-O`Clock.jpg",
    name: "Wild O`Clock",
  },
  slots165: {
    redirectUrl: "/casino/ezugi/WildChest",
    imgUrl: "./images/slots/newCasino/Wild-Wild-Chest.jpg",
    name: "Wild Wild Chest",
  },
  slots166: {
    redirectUrl: "/casino/ezugi/WinEscalator",
    imgUrl: "./images/slots/newCasino/Win-Escalator.jpg",
    name: "Win Escalator",
  },
  slots167: {
    redirectUrl: "/casino/ezugi/YucatanMystery",
    imgUrl: "./images/slots/newCasino/Yucatan`s-Mystery.jpg",
    name: "Yucatan`s Mystery",
  },
};
